module.exports = __webpack_public_path__ + "COBRA_Plan_and_Rate_Information.xlsx";